import {
  getFlightDetails,
  getPriceString,
  sortMseByPrice,
  getMessageList
} from '@stencil/flights-utils/src/srp-thor-utils';
import dateformat from 'dateformat';
import sendDataToNewrelic from '@stencil/send-data-to-new-relic';

export const stopsFilterFunction = (itemObj, valuesToBeFilteredOn) => {
  let item = itemObj;
  let flag = false;
  let minPrice = Infinity;
  valuesToBeFilteredOn.forEach(value => {
    switch (value) {
      case '0':
        if ('minCostNonStopArray' in item) {
          const minCostNonStopArray = item?.minCostNonStopArray;
          for (let i = 0; i < minCostNonStopArray?.length; i++) {
            if (minCostNonStopArray[i].price < minPrice) {
              item.minCostStop = minCostNonStopArray[i];
              minPrice = minCostNonStopArray[i].price;
              flag = true;
            }
          }
        }
        break;
      case '1':
        if ('minCostOneStopArray' in item) {
          const minCostOneStopArray = item?.minCostOneStopArray;
          for (let i = 0; i < minCostOneStopArray?.length; i++) {
            if (minCostOneStopArray[i].price < minPrice) {
              item.minCostStop = minCostOneStopArray[i];
              minPrice = minCostOneStopArray[i].price;
              flag = true;
            }
          }
        }
        break;
      case '2':
        if ('minCostOnePlusStopArray' in item) {
          const minCostOnePlusStopArray = item?.minCostOnePlusStopArray;
          for (let i = 0; i < minCostOnePlusStopArray?.length; i++) {
            if (minCostOnePlusStopArray[i].price < minPrice) {
              item.minCostStop = minCostOnePlusStopArray[i];
              minPrice = minCostOnePlusStopArray[i].price;
              flag = true;
            }
          }
        }
        break;
    }
  });
  return flag;
};

export const priceFilterFunction = (item, minMax) => {
  let flag = false;
  if (item.minCostStop.price >= minMax[0].min && item.minCostStop.price <= minMax[0].max) {
    flag = true;
  }

  return flag;
};

export const durationFilterFunction = (item, minMax) => {
  let flag = false;
  if (
    parseInt(item?.minCostStop?.onwardFlightDurationInMins || 0) +
      parseInt(item?.minCostStop?.returnFlightDurationInMins || 0) >=
      minMax[0].min &&
    parseInt(item?.minCostStop?.onwardFlightDurationInMins || 0) +
      parseInt(item?.minCostStop?.returnFlightDurationInMins || 0) <=
      minMax[0].max
  ) {
    flag = true;
  }
  return flag;
};

export const famousForFilterFunction = (item, valuesToBeFilteredOn) => {
  let flag = false;
  valuesToBeFilteredOn.forEach(value => {
    if (item.categories && item.categories.includes(value)) {
      flag = true;
    }
  });
  return flag;
};

export const showCountriesFilterFunction = (item, valuesToBeFilteredOn) => {
  let flag = false;
  valuesToBeFilteredOn.forEach(value => {
    switch (value) {
      case 'visa-on-arrival':
        if (item.visa === 'visa-on-arrival') {
          flag = true;
        }
        break;
      case 'e-visa':
        if (item.visa === 'e-visa') {
          flag = true;
        }
        break;
      case 'visa-free':
        if (item.visa === 'visa-free') {
          flag = true;
        }
        break;
    }
  });
  return flag;
};

export function getFilterMinMaxValues(flightItem, filterMinMaxValues, journey, price, index) {
  try {
    if (flightItem.f.length > 1) {
      let multiFlag = false;
      for (let i = 1; i < flightItem.f.length; i++) {
        if (flightItem.f[i].c !== flightItem.f[i - 1].c) {
          multiFlag = true;
          break;
        }
      }
      if (multiFlag) {
        if (filterMinMaxValues.carriers['multi']) {
          if (filterMinMaxValues.carriers['multi'][journey]) {
            if (price < filterMinMaxValues.carriers['multi'][journey].price) {
              filterMinMaxValues.carriers['multi'][journey].price = price;
              filterMinMaxValues.carriers['multi'][journey].index = index;
            }
          } else {
            filterMinMaxValues.carriers['multi'][journey] = {
              price: null,
              index: null
            };
            filterMinMaxValues.carriers['multi'][journey].price = price;
            filterMinMaxValues.carriers['multi'][journey].index = index;
          }
        } else {
          filterMinMaxValues.carriers['multi'] = {
            [journey]: {
              price: null,
              index: null
            }
          };
          filterMinMaxValues.carriers['multi'][journey].price = price;
          filterMinMaxValues.carriers['multi'][journey].index = index;
        }
      } else {
        if (filterMinMaxValues.carriers[flightItem.f[0].c]) {
          if (filterMinMaxValues.carriers[flightItem.f[0].c][journey]) {
            if (price < filterMinMaxValues.carriers[flightItem.f[0].c][journey].price) {
              filterMinMaxValues.carriers[flightItem.f[0].c][journey].price = price;
              filterMinMaxValues.carriers[flightItem.f[0].c][journey].index = index;
            }
          } else {
            filterMinMaxValues.carriers[flightItem.f[0].c][journey] = {
              price: null,
              index: null
            };
            filterMinMaxValues.carriers[flightItem.f[0].c][journey].price = price;
            filterMinMaxValues.carriers[flightItem.f[0].c][journey].index = index;
          }
        } else {
          filterMinMaxValues.carriers[flightItem.f[0].c] = {
            [journey]: {
              price: null,
              index: null
            }
          };
          filterMinMaxValues.carriers[flightItem.f[0].c][journey].price = price;
          filterMinMaxValues.carriers[flightItem.f[0].c][journey].index = index;
        }
      }
    } else {
      if (filterMinMaxValues.carriers[flightItem.f[0].c]) {
        if (filterMinMaxValues.carriers[flightItem.f[0].c][journey]) {
          if (price < filterMinMaxValues.carriers[flightItem.f[0].c][journey].price) {
            filterMinMaxValues.carriers[flightItem.f[0].c][journey].price = price;
            filterMinMaxValues.carriers[flightItem.f[0].c][journey].index = index;
          }
        } else {
          filterMinMaxValues.carriers[flightItem.f[0].c][journey] = {
            price: null,
            index: null
          };
          filterMinMaxValues.carriers[flightItem.f[0].c][journey].price = price;
          filterMinMaxValues.carriers[flightItem.f[0].c][journey].index = index;
        }
      } else {
        filterMinMaxValues.carriers[flightItem.f[0].c] = {
          [journey]: {
            price: null,
            index: null
          }
        };
        filterMinMaxValues.carriers[flightItem.f[0].c][journey].price = price;
        filterMinMaxValues.carriers[flightItem.f[0].c][journey].index = index;
      }
    }
    return filterMinMaxValues;
  } catch (err) {
    sendDataToNewrelic('GetFilterMinMaxValues', `Failed with error: ${err}`);
  }
}

function getCardDateObject(dateObj) {
  if (!dateObj) {
    return null;
  }
  return {
    dateObj: dateObj.toString(),
    day: dateformat(dateObj, 'dddd'),
    date: dateformat(dateObj, 'dd'),
    dateOnCard: dateformat(dateObj, 'ddd, dd mmm')
  };
}

export const getDateFromYYYYMMDDString = dateInYYYYMMDD => {
  const newDate = new Date(
    dateInYYYYMMDD.substring(0, 4),
    dateInYYYYMMDD.substring(4, 6) - 1,
    dateInYYYYMMDD.substring(6, 8)
  );
  return newDate;
};

const getAlternateTimeText = (flight, datesArr, source, destination, departure, arrival) => {
  let onwardAlternateText = '';
  let returnAlternateText = '';

  const onwardDate = datesArr[flight.f[0]['1']].toString();
  if (onwardDate !== departure.yyyymmdd) {
    const onwardDateObj = getCardDateObject(getDateFromYYYYMMDDString(onwardDate));
    onwardAlternateText = `Fly on ${onwardDateObj.dateOnCard}`;
  }
  if (flight.r) {
    const returnDate = datesArr[flight.r.f[0]['1']].toString();
    if (returnDate !== arrival.yyyymmdd) {
      const returnDateObj = getCardDateObject(getDateFromYYYYMMDDString(returnDate));
      returnAlternateText = `Return on ${returnDateObj.dateOnCard}`;
    }
  }
  if (onwardAlternateText !== '' && returnAlternateText !== '') {
    return `${onwardAlternateText} and ${returnAlternateText}`;
  } else if (onwardAlternateText !== '') {
    return onwardAlternateText;
  }
  return returnAlternateText;
};

function getDurationForDisplay(dur) {
  return (dur / 100).toFixed(2).replace('.', 'h ') + 'm';
}

const getAlternateSaveText = flight => {
  let saveText = '';
  let hasFareSave = false;
  if (flight.fs) {
    saveText = getPriceString(flight.fs);
    hasFareSave = true;
  } else if (flight.ts) {
    saveText = getDurationForDisplay(flight.ts);
  }
  return {
    saveText,
    hasFareSave
  };
};

const getAlternateLocationText = (flight, airportsArr, source, destination) => {
  if (flight.nd) {
    const from = airportsArr[flight.f[0].u];
    const to = airportsArr[flight.f[flight.f.length - 1].g];
    return `Fly ${
      flight.nf === 1
        ? `from ${from.t}, approx ${flight.nd}KM from ${source.iata}`
        : `to ${to.t}, approx ${flight.nd}KM from ${destination.iata}`
    }`;
  } else if (flight.r && flight.r.nd) {
    const from = airportsArr[flight.r.f[0].u];
    const to = airportsArr[flight.r.f[flight.r.f.length - 1].g];
    return `Fly ${
      flight.nf === 1
        ? `from ${from.t}, approx ${flight.nd}KM from ${destination.iata}`
        : `to ${to.t}, approx ${flight.nd}KM from ${source.iata}`
    }`;
  }
};

const getAlternateFlightDetails = (flight, addInfo) => {
  if (flight.alternateTime) {
    const { datesArr, source, destination, departure, arrival } = addInfo;
    const alternateText = getAlternateTimeText(
      flight,
      datesArr,
      source,
      destination,
      departure,
      arrival
    );
    const { saveText, hasFareSave } = getAlternateSaveText(flight);
    return {
      alternateText,
      saveText,
      hasFareSave
    };
  } else {
    const { airportsArr, source, destination } = addInfo;
    const alternateText = getAlternateLocationText(flight, airportsArr, source, destination);
    const { saveText, hasFareSave } = getAlternateSaveText(flight);
    return {
      alternateText,
      saveText,
      hasFareSave
    };
  }
};

export function formatFlightForDisplay(displayInformation) {
  const {
    flightList,
    refundabilityArr,
    airportsArr,
    carriersArr,
    datesArr,
    textArr,
    valueArr,
    iconArr,
    discountFares,
    discountMessages,
    originalIndex,
    showOnePaxPrice,
    source,
    destination,
    departure,
    arrival
  } = displayInformation;
  const flight = flightList[0];
  const onwardFlight = getFlightDetails({
    flight,
    refundabilityArr,
    airportsArr,
    carriersArr,
    datesArr,
    valueArr,
    discountFares,
    discountMessages,
    originalIndex,
    showOnePaxPrice
  });
  const returnFlight = flight.r
    ? getFlightDetails({
        flight: flight.r,
        refundabilityArr,
        airportsArr,
        carriersArr,
        datesArr,
        valueArr,
        discountFares,
        discountMessages,
        originalIndex,
        showOnePaxPrice
      })
    : null;

  const priceToShow = showOnePaxPrice ? 'p1' : 'p';

  let ancillaryList = undefined;
  if (flight.al && flight.al.length > 0) {
    ancillaryList = flight.al.map(ancillary => {
      const header = valueArr[ancillary.n];
      const headerIcon = iconArr[ancillary.nu] || '';
      const detailsList = [];
      const detailsLen = ancillary.t?.length || 0;
      for (let i = 0; i < detailsLen; i++) {
        const temp = {
          t: typeof ancillary.t[i] !== 'undefined' ? textArr[ancillary.t[i]] : '',
          v: typeof ancillary.v[i] !== 'undefined' ? valueArr[ancillary.v[i]] : '',
          i: typeof ancillary.i[i] !== 'undefined' ? iconArr[ancillary.i[i]] : '',
          isCommon: false
        };
        detailsList.push(temp);
      }
      const commonList = (flight.ac && flight.ac.t && flight.ac.t.length) || 0;
      for (let i = 0; i < commonList; i++) {
        const temp = {
          t: typeof flight.ac.t[i] !== 'undefined' ? textArr[flight.ac.t[i]] : '',
          v: typeof flight.ac.v[i] !== 'undefined' ? valueArr[flight.ac.v[i]] : '',
          i: typeof flight.ac.i[i] !== 'undefined' ? iconArr[flight.ac.i[i]] : '',
          isCommon: true
        };
        detailsList.push(temp);
      }
      const bundleAmt = getPriceString(parseInt(ancillary.af, 10));
      const tag = typeof ancillary.b !== 'undefined' ? iconArr[ancillary.b] : '';
      const hasPriceLock =
        flight.li && flight.li.a && ancillary.fc && ancillary.fc === 1 ? true : false;
      return {
        header,
        headerIcon,
        detailsList,
        bundleAmt,
        tag,
        hasPriceLock
      };
    });
  }

  const isMSE = flightList.length > 1;
  const isExtraSeatFlight = flight.st && (flight.st === 7 || flight.st === 8);
  const extraSeatType = isExtraSeatFlight ? flight.st : null;

  let mseList = undefined;
  if (flightList.length > 1) {
    mseList = flightList.sort(sortMseByPrice).map((flightItem, index) => {
      const pricePerPerson = getPriceString(flightItem.p1);
      const price = getPriceString(flightItem.p);
      const priceToDisplay = getPriceString(flightItem[priceToShow]);
      let discountedFare = undefined;
      let disMessage = undefined;
      let discount = undefined;
      if (flightItem[5] && flightItem[7] && flightItem[8]) {
        disMessage = discountMessages[flightItem[8]];
        discountedFare = getPriceString(flightItem[5]);
        discount = getPriceString(discountFares[flightItem[7]]);
      }
      const messageList = flightItem.ml
        ? getMessageList(
            flightItem.ml.t,
            textArr,
            flightItem.ml.v,
            valueArr,
            flightItem.ml.i,
            iconArr
          )
        : [];
      // flightItem.ml &&
      // flightItem.ml.t &&
      // flightItem.ml.v &&
      // flightItem.ml.t.map((key, index) => {
      //   return textArr[key].replace('%s', valueArr[flightItem.ml.v[index]]);
      // });
      return {
        messageList,
        pricePerPerson,
        price,
        priceToDisplay,
        ...(disMessage ? { disMessage } : null),
        ...(discountedFare ? { discountedFare } : null),
        ...(discount ? { discount } : null),
        fareText: `Fare ${index + 1}`
      };
    });
  }

  let alternateFlightInfo = undefined;
  if (flight.alternateTime) {
    alternateFlightInfo = getAlternateFlightDetails(flight, {
      datesArr,
      source,
      destination,
      departure,
      arrival
    });
  } else if (flight.alternateLocation) {
    alternateFlightInfo = getAlternateFlightDetails(flight, { airportsArr, source, destination });
  }

  const priceLockFareDetails = flight.li && flight.li.a ? flight.li : null;
  if (priceLockFareDetails) {
    priceLockFareDetails.expiry = valueArr[priceLockFareDetails.e];
    const fare = onwardFlight.discountedFare
      ? onwardFlight.discountedFare
      : onwardFlight.priceToDisplay;
    priceLockFareDetails.remainingAmount =
      parseInt(fare.replace(/,/g, '')) - parseInt(priceLockFareDetails.f);
    priceLockFareDetails.remainingTotalAmount =
      parseInt(onwardFlight.price.replace(/,/g, '')) - parseInt(priceLockFareDetails.tf);
  }

  return {
    ...onwardFlight,
    ...(isMSE ? { isMSE } : null),
    ...(returnFlight ? { returnFlight } : null),
    ...(ancillaryList ? { ancillaryList } : null),
    ...(mseList ? { mseList } : null),
    ...(flight.alternateTime ? { alternateTime: true } : null),
    ...(flight.alternateLocation ? { alternateLocation: true } : null),
    ...(alternateFlightInfo ? { ...alternateFlightInfo } : null),
    ...(isExtraSeatFlight ? { isExtraSeatFlight } : null),
    ...(extraSeatType ? { extraSeatType } : null),
    ...(priceLockFareDetails ? { priceLockFareDetails } : null)
  };
}

export function createDisplayFlights(sourceList, displayInformation, currentLength) {
  const displayFlights = sourceList.map((flight, index) =>
    formatFlightForDisplay({
      flightList: flight,
      ...displayInformation,
      originalIndex: currentLength + index
    })
  );
  return displayFlights;
}

export function parseDomesticRoundTripDiscounts(discountObj) {
  const onwardDiscounts = {};
  const returnDiscounts = {};
  Object.entries(discountObj).forEach(([key, value]) => {
    if (key.indexOf('o') !== -1 && key.indexOf('r') !== -1) {
      const onwardIndex = parseInt(key.split('o')[1].split('r')[0]);
      const returnIndex = parseInt(key.split('r')[1]);
      const returnDiscountArr =
        onwardDiscounts[onwardIndex] && onwardDiscounts[onwardIndex].returnIndex
          ? onwardDiscounts[onwardIndex].returnIndex
          : [];
      onwardDiscounts[onwardIndex] = {
        ...onwardDiscounts[onwardIndex],
        returnIndex: [
          ...returnDiscountArr,
          {
            index: returnIndex,
            discount: value
          }
        ]
      };
      const onwardDiscountArr =
        returnDiscounts[returnIndex] && returnDiscounts[returnIndex].onwardIndex
          ? returnDiscounts[returnIndex].onwardIndex
          : [];
      returnDiscounts[returnIndex] = {
        ...returnDiscounts[returnIndex],
        onwardIndex: [
          ...onwardDiscountArr,
          {
            index: onwardIndex,
            discount: value
          }
        ]
      };
    } else if (key.indexOf('o') !== -1 && key.indexOf('r') === -1) {
      const index = parseInt(key.split('o')[1]);
      onwardDiscounts[index] = {
        discount: value
      };
    } else if (key.indexOf('o') === -1 && key.indexOf('r') !== -1) {
      const index = parseInt(key.split('r')[1]);
      returnDiscounts[index] = {
        discount: value
      };
    }
  });
  return {
    onwardDiscounts,
    returnDiscounts
  };
}

export const getTempSrcDestObj = (airports, iataFromUrl) => {
  for (let index = 0; index < airports.length; index++) {
    let currAirport = airports[index];
    if (currAirport.i === iataFromUrl) {
      return {
        n: currAirport.n,
        iata: currAirport.i,
        ct: { n: currAirport.t },
        xtr: {
          cn: currAirport.t,
          cc: currAirport.d,
          cnt_n: currAirport.c
        }
      };
    }
  }
};

export function isPastNumberOfDays(date: Date, noOfDays: number) {
  const today = new Date();
  const dateToCompareWith =
    noOfDays > 0 ? new Date(today.setDate(today.getDate() + noOfDays)) : today;
  return date.setHours(0, 0, 0, 0) - dateToCompareWith.setHours(0, 0, 0, 0) < 0;
}

export const getSrpQueryParams = (flightSearchData, query = false) => {
  const {
    source,
    destination,
    departure,
    arrival,
    passengers,
    flightClass,
    journeyType,
    travelType
  } = flightSearchData;
  const EMPTY_STRING = '';
  const DOMESTIC = 'domestic';
  const DOMESTIC_TYPE = query ? '-100--' : '-D';
  const INTERNATIONAL_TYPE = query ? '-0' : '-I';
  return `${source.iata}-${destination.iata}-${departure.yyyymmdd}-${
    journeyType === 'rt' ? arrival?.yyyymmdd : EMPTY_STRING
  }-${passengers.adult}-${passengers.child}-${passengers.infant}-${flightClass.value}${
    travelType === DOMESTIC ? DOMESTIC_TYPE : INTERNATIONAL_TYPE
  }`;
};
